[
  {
    "code": "TO-01",
    "name": "'Eua"
  },
  {
    "code": "TO-02",
    "name": "Ha'apai"
  },
  {
    "code": "TO-03",
    "name": "Niuas"
  },
  {
    "code": "TO-04",
    "name": "Tongatapu"
  },
  {
    "code": "TO-05",
    "name": "Vava'u"
  }
]